import { AnyStore } from 'stores/anyStore';

export const displayScrollStore = new AnyStore(false);
